
export async function csrfFetch(url, args) {
  const csrfToken = document.querySelector("[name='csrf-token']").content;
  return fetch(url, {...args, credentials: 'include', headers: { ...args.headers, "X-CSRF-Token": csrfToken }});
}